import { Component } from '@angular/core';
import { PageService } from '@bds/core';

@Component({
    selector: 'app-routes-screen',
    template: ` <router-outlet></router-outlet>`,
})
export class RoutesScreenComponent {
    constructor(private pageService: PageService) {
        this.pageService.setHeader('Routes');
    }
}
